import React, { useCallback, useMemo } from 'react';
import columns from './columns';
import Table from '@components/common/Table';
import { useTableSort, useSearch } from '@components/common/Table/hooks';
import { Input, Spin } from 'antd';
import { debounce } from 'lodash';

const defaultSort = { key: 'customer.name', order: 'asc' };
interface IAccountTableProps {
  profiles: any[];
  isFetching: boolean;
}

const AccountTable = ({ profiles, isFetching }: IAccountTableProps) => {
  const { sortBy, onColumnSort, sortedData } = useTableSort({ data: profiles, defaultSort });

  const { filteredRows, onSearch } = useSearch({
    data: sortedData,
    columnKey: 'customer.name',
  });

  const debouncedOnSearch = useMemo(() => debounce(onSearch, 200), [onSearch]);

  const { Search } = Input;

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      debouncedOnSearch(value);
    },
    [debouncedOnSearch],
  );

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', height: 45 }}>
        <Search
          placeholder="Search by account name"
          enterButton
          onChange={handleChange}
          onSearch={onSearch}
          style={{ width: 250 }}
        />
        <div>
          <Spin tip="Refreshing data..." size="small" spinning={isFetching} />
        </div>
      </div>
      <Table
        data={filteredRows}
        columns={columns}
        fixed
        onColumnSort={onColumnSort}
        sortBy={sortBy}
      />
    </>
  );
};

export default AccountTable;
